import { columns } from 'containers/Pages/Assets/Assets/columns';
import { getItemOrDefaultToValue, nestedDisplay } from '../../details';
import assetCategories from 'static/asset_categories.json';

export const transform = (data, assetListData, assetListColumns = columns) => {
  const departmentsToDisplay = data?.departmentForDetails
    ? data?.departmentForDetails
    : [];
  const categoryImage = assetCategories.find(f => {
    return f.id === data.category;
  });

  return {
    generalInfo: {
      assetTypeId: {
        type: 'text',
        label: 'Asset Type ID',
        value: getItemOrDefaultToValue(data, 'assetTypeId', '-'),
      },
      category: {
        type: 'icons',
        value: categoryImage?.icon || '',
        label: data.category,
      },
      name: {
        type: 'text',
        value: getItemOrDefaultToValue(data, 'name', '-'),
      },
      handoverRequired: {
        type: 'boolean',
        value: getItemOrDefaultToValue(data, 'handoverRequired', '-'),
      },
      qualificationRequired: {
        type: 'boolean',
        value: getItemOrDefaultToValue(data, 'qualificationRequired', '-'),
      },
      archived: {
        type: 'boolean',
        value: getItemOrDefaultToValue(data, 'archived', '-'),
      },
      departments: {
        type: 'array',
        value: nestedDisplay(departmentsToDisplay),
      },
    },
    detailedInfo: {
      description: {
        type: 'text',
        value: getItemOrDefaultToValue(data, 'description', '-'),
      },
      assetList: {
        type: 'list-data',
        value: {
          data: [],
          columns: assetListColumns,
        },
      },
    },
    others: {
      id: { value: data.id },
      category: {
        type: 'text',
        value: data.category,
      },
    },
  };
};
